import React from 'react';
import { Modal, message } from 'antd';
import { CloseOutlined, CopyOutlined } from '@ant-design/icons';
import type { TProviderFaxNumber } from 'types/eFax';
import s from './s.module.less';

type Props = {
    open: boolean;
    onClose: () => void;
    onRequestCancelService: () => void;
    faxNumber?: TProviderFaxNumber | null;
};

const EfaxSettingsDrawer = ({ open, onClose, onRequestCancelService, faxNumber }: Props) => {
    const displayNumber = faxNumber?.faxNumberDisplay || faxNumber?.faxNumber || '—';
    const rawNumber = faxNumber?.faxNumber || '';

    const handleCopy = () => {
        if (!rawNumber) return;
        navigator.clipboard.writeText(rawNumber).then(() => {
            message.success('Fax number copied!');
        });
    };

    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            closable={false}
            width={650}
            centered
            className={s.modalRoot}
            styles={{ body: { padding: 0 } }}
            destroyOnClose
        >
            <div className={s.header}>
                <span className={s.title}>Settings</span>
                <button type="button" className={s.closeBtn} onClick={onClose} aria-label="Close settings">
                    <CloseOutlined className={s.closeIcon} />
                </button>
            </div>

            <div className={s.body}>
                <div className={s.infoRow}>
                    <span className={s.infoLabel}>eFax Status</span>
                    <span className={s.statusBadge}>Active</span>
                </div>

                <div className={s.infoRow}>
                    <span className={s.infoLabel}>Fax Number</span>
                    <span className={s.infoValue}>{displayNumber}</span>
                    <button type="button" className={s.copyBtn} onClick={handleCopy} aria-label="Copy fax number">
                        <CopyOutlined />
                    </button>
                </div>

                <div className={s.infoRow}>
                    <span className={s.infoLabel}>Plan</span>
                    <span className={s.infoValue}>$9.9/month — 250 pages included</span>
                </div>

                <div className={s.divider} />

                <button type="button" className={s.cancelLink} onClick={onRequestCancelService}>
                    Cancel eFax
                </button>
            </div>
        </Modal>
    );
};

export default EfaxSettingsDrawer;
